import { CssBaseline as MUICssBaseline, makeStyles } from '@material-ui/core';
import React from 'react';
import { giftingRoutes } from '../../constants/routeConstant';
import { fadeColor, lightenColor } from '../../utils/styles';


const useStyles = makeStyles((theme) => ({
    '@global': {
        body: {
            minWidth: "280px",
            background: theme.palette.ascents.black,
            backgroundSize: 'cover !important',
            // backgroundRepeat: 'repeat',
            overflowX: 'hidden',
            [theme.breakpoints.down('xs')]: {
                backgroundPositionX: 'center'
            }
        },
        '*::-webkit-scrollbar': {
            width: "7px",
            height: "7px",
        },
        '*::-webkit-scrollbar-button': {
            width: "0",
            height: "0",
        },
        '*::-webkit-scrollbar-track': {
            background: lightenColor(theme.palette.ascents.secondary, 0.45),
            border: "0px none #ffffff",
            borderRadius: "0",
            '&:hover,&:active': {
                background: lightenColor(theme.palette.ascents.secondary, 0.45),
            }
        },
        '*::-webkit-scrollbar-track-piece': {

        },
        '*::-webkit-scrollbar-thumb': {
            background: lightenColor(theme.palette.ascents.secondary, 0.15),
            border: "0px none #ffffff",
            borderRadius: "0",
            '&:hover,&:active': {
                background: lightenColor(theme.palette.ascents.secondary, 0),
            }
        },
        '*::-webkit-scrollbar-corner': {
            background: "transparent",
        },
        small: {
            color: "#ff6767",
        },
        a: {
            textDecoration: 'none'
        },
        InputBase: {
            color: theme.palette.ascents.textLight,
        },

        '.MuiPopover-paper': {
            background: '#202020 !important'
        },

        ".MuiButton-contained": {
            boxShadow: "none",
        },

        ".MuiButton-contained.Mui-disabled": {
            backgroundColor: "inherit",
            color: "inherit",

            "&.MuiButton-containedPrimary": {
                backgroundColor: fadeColor(theme.palette.ascents.primary, 0.8),
                // color: theme.palette.ascents.white,
            },
        },

        ".MuiButton-outlined.Mui-disabled": {
            border: `1px solid ${theme.palette.ascents.textGrey}`,
            color: theme.palette.ascents.textGrey,
        },

        '.MuiTouchRipple-child': {
            background: `${theme.palette.ascents.white}`,
            opacity: "1 !important",
        },

        '.MuiTouchRipple-root': {
            opacity: "1 !important",
        },

        ".MuiTabs-indicator": {
            background: `linear-gradient(45deg, ${theme.palette.ascents.primary} 20% ,${theme.palette.ascents.orange} 80%)`,
        },

        ".MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover": {
            background: `linear-gradient(90deg,${fadeColor(theme.palette.ascents.primary, 0.9)}, ${fadeColor(theme.palette.ascents.orange, 0.8)})`
        },

        ".MuiTooltip-tooltip": {
            fontSize: "0.75rem",
            background: theme.palette.ascents.textDark,
            color: theme.palette.ascents.primary,
            fontWeight: "400",
            border: `1px solid ${theme.palette.ascents.primary}`,
            boxShadow: "0px 0px 4px 2px rgba(0,0,0,0.25)"
        },

        ".MuiButton-outlined": {
            backgroundColor: `${theme.palette.ascents.white} !important`,
            '& .MuiTouchRipple-child': {
                background: `${theme.palette.ascents.primary}`,
                opacity: "1 !important",
            },
        },
        '.MuiFab-root': {
            textTransform: 'capitalize'
        },
        '.MuiDivider-root': {
            backgroundColor: 'rgba(219, 188, 78, 10%)'
        },
        '.swal2-container': {
            zIndex: 99999999
        },
        '.sentry-error-embed-wrapper': {
            zIndex: '999999999 !important'
        },
        // '.razorpay-backdrop': {
        //     display: 'none'
        // }
        '#tsparticles': {
            position: 'absolute',
            height: '100vh',
            width: '100vw'
        },
        'input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active, input:-internal-autofill-selected, input:-internal-autofill-previewed': {
            '-webkit-box-shadow': '0 0 0 0px rgba(255,255,255,0) inset !important',
            backgroundColor: "rgba(255,255,255,0) !important",
            transitionDelay: '999999s !important',
        },
        'input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            '-moz-appearance': 'none',
            'appearance': 'none',
            'margin': 0,
        },

        '*::-webkit-calendar-picker-indicator': {
            filter: `invert(1)`
        }
    },
}));


const CssBaseline = ({ ascent = "primary", className, children, ...props }) => {

    const classes = useStyles({ ascent, isGiftingScreen: window.location.pathname === giftingRoutes.GIFTING });

    return (
        <MUICssBaseline classes={classes} />
    );
};

CssBaseline.propTypes = {

};

export default CssBaseline;